import { BrowserRouter } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import { AppRoutes } from "./router";
import i18n from "./i18n";
import { FavoritesProvider } from "./hooks/useFavorites";
import { ToastProvider } from "./hooks/useToast";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <ToastProvider>
        <FavoritesProvider>
          <BrowserRouter basename={__BASE_PATH__}>
            <AppRoutes />
          </BrowserRouter>
        </FavoritesProvider>
      </ToastProvider>
    </I18nextProvider>
  );
}

export default App;